import { t } from "i18next";

const LANG_BASE = "vessel-call.port-services";

export const OPERATION_TYPE_OPTIONS = [
  { value: "LOADING", label: t(`${LANG_BASE}.fields.loading`) },
  {
    value: "OFFLOADING",
    label: t(`${LANG_BASE}.fields.offloading`),
  },
  {
    value: "LOAD_AND_DISCHARGE",
    label: t(`${LANG_BASE}.fields.load-and-discharge`),
  },
];
